<template>
  <div v-if="isImpersonation" class="impersonation-banner">
    <div class="impersonation-banner__text">
      <strong>Impersonation session</strong>
      <span v-if="userName"> — viewing as {{ userName }}</span>
      <span class="impersonation-banner__badge">read-only</span>
      <span v-if="expiresLabel" class="impersonation-banner__expires">
        expires at {{ expiresLabel }}
      </span>
    </div>
    <b-button
      size="sm"
      variant="light"
      :disabled="loggingOut"
      @click="onLogout"
    >
      Log out of impersonation
    </b-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ImpersonationBanner',
  data() {
    return {
      loggingOut: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      isImpersonation: 'user/isImpersonation',
      impersonationExpiresAt: 'user/impersonationExpiresAt',
    }),
    userName() {
      if (!this.user) return ''
      const parts = [this.user.firstName, this.user.lastName].filter(Boolean)
      return parts.join(' ') || this.user.email || ''
    },
    expiresLabel() {
      if (!this.impersonationExpiresAt) return ''
      return this.$dayjs
        .utc(this.impersonationExpiresAt)
        .local()
        .format('HH:mm')
    },
  },
  methods: {
    ...mapActions({
      pretendLogout: 'user/pretendLogout',
    }),
    async onLogout() {
      if (this.loggingOut) return
      this.loggingOut = true
      try {
        await this.pretendLogout()
      } finally {
        this.loggingOut = false
      }
    },
  },
}
</script>

<style scoped>
.impersonation-banner {
  position: sticky;
  top: 0;
  z-index: 1080;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.5rem 1rem;
  background-color: #b8860b;
  color: #fff;
  font-size: 0.9rem;
}
.impersonation-banner__text {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}
.impersonation-banner__badge {
  display: inline-block;
  padding: 0.1rem 0.45rem;
  border-radius: 0.25rem;
  background-color: rgba(0, 0, 0, 0.25);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.impersonation-banner__expires {
  opacity: 0.9;
}
</style>
